import "./product-title.scss";

import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";
import { atomSelectedProduct } from "src/storage";

export const useProductTitle = () => {
  const { t } = useTranslation();

  const product = useRecoilValue(atomSelectedProduct);

  return {
    t,
    product,
  };
};
